import {API} from "./API";
import {Notification} from "../models/Notification";

export class NotificationsAPI extends API<Notification> {

	constructor () {
		super("notifications");
    }

	markSeen (id: string) {

		let url = `/notifications/${id}/seen`;
		return API.axiosInstance.put(url);
	}
}
